import { render, staticRenderFns } from "./time-log-starter-inputs.vue?vue&type=template&id=f04adf84&"
import script from "./time-log-starter-inputs.vue?vue&type=script&lang=js&"
export * from "./time-log-starter-inputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports